import { RootState } from "../store";

const transactionSelectors = {
  getTransactions: (state: RootState) => state.transaction.transaction,
  getUserTransactions: (state: RootState) => state.transaction.userTransaction,
  getWalletTransactions: (state: RootState) => state.transaction.walletTransaction,
  getLoader: (state: RootState) => state.transaction.loaders,
};

export default transactionSelectors;
